import { render } from "./product-form-option.vue?vue&type=template&id=91971bca"
import script from "./product-form-option.vue?vue&type=script&lang=js"
export * from "./product-form-option.vue?vue&type=script&lang=js"

import "./product-form-option.vue?vue&type=style&index=0&id=91971bca&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__